<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import MediaInteraction from '../../interactions/media/MediaInteraction.svelte';
    import { getReadonlyMediaInteractionProps } from '../util/readonlyProps.js';

    let props = $props();

    let newProps = $derived(getReadonlyMediaInteractionProps(props));
</script>

<MediaInteraction {...newProps} />
